import { Grid, Box, Typography } from '@mui/material';

import Form from 'components/Form';
import { IFormValues } from 'routes/Main/type';

import SectionTitle from '../components/SectionTitle';

interface Props extends IFormValues {
  disabled?: boolean;
}

const checks01 = [
  {
    label: '입원 전 6개월 내 낙상 일회 이상의 병력',
    key: 'assessment.checked1',
  },
  {
    label: '환자가 당 입원 기간 동안 한 번의 낙상을 경험하였다.',
    key: 'assessment.checked2',
  },
  {
    label: '환자가 규약에 의하여 낙상-위험으로 간주된다. (예: 발작 예방 조치)',
    key: 'assessment.checked3',
  },
];

const checks02 = [
  {
    label: '완전한 마비 또는 완전히 움직이지 못한다.',
    key: 'assessment.checked4',
  },
];

const EducationList = (props: Props) => {
  const { disabled, getValues, setValue } = props;

  return (
    <>
      <SectionTitle title="존스홉킨스 낙상 위험 사정 도구" />
      <Box
        sx={{
          margin: '48px auto 30px auto',
          width: '96%',
          border: '1px solid #00000053',
          padding: '10px',
          borderRadius: '4px',
        }}
      >
        <Grid container xs={11}>
          <Typography sx={{ fontSize: '12px', fontWeight: 500 }}>
            만약 환자가 다음 조건들 중 어느 것이든 해당하면, 그 상자에 표시하고
            지시된 대로 낙상 위험 중재들을 적용하시오
            <br />
            <br />고 낙상 위험 - 규약에 의하여 고 낙상 위험 중재들을 시행하시오
          </Typography>

          {checks01.map((v, i) => {
            return (
              <Grid item xs={11.5}>
                <Form.MuiCheckbox
                  label={v.label}
                  disabled={disabled}
                  defaultValue={Boolean(getValues(v.key)) ? [v.label] : []}
                  onChange={(_, checked) => {
                    setValue(v.key, checked);
                  }}
                />
              </Grid>
            );
          })}
          <Typography
            sx={{ fontSize: '12px', fontWeight: 500, marginTop: '10px' }}
          >
            저 낙상 위험 - 규약에 의하여 저 낙상 위험 중재들을 시행하시오
          </Typography>
          {checks02.map((v, i) => {
            return (
              <Grid item xs={11.5}>
                <Form.MuiCheckbox
                  label={v.label}
                  disabled={disabled}
                  defaultValue={Boolean(getValues(v.key)) ? [v.label] : []}
                  onChange={(_, checked) => {
                    setValue(v.key, checked);
                  }}
                />
              </Grid>
            );
          })}
        </Grid>
        <Typography
          sx={{ margin: '20px 0 20px 0', fontSize: '12px', fontWeight: 400 }}
        >
          상기 조건들 중 어느 것이든 표시된다면 낙상 위험 점수를 계속하지 마시오
        </Typography>
      </Box>
    </>
  );
};

export default EducationList;
